import gql from 'graphql-tag';


const userFields = gql`
fragment userFields on User {
    id
    email
    name
}`;

const aclFields = gql`
fragment aclFields on ACL {
    id
    role
    objectId
    objectType
    parentObjectId
    user {
        id
        email
    }
}`;

const deletePermissionFields = gql`
fragment deletePermissionFields on DeletePermission {
  canDelete
  reasons
}`;

const stateFields = gql`
fragment stateFields on State {
  id
  type
  name
  location
  flowId
  deletePermission {
    ...deletePermissionFields
  }
}
${deletePermissionFields}`;

const pluginFields = gql`
fragment pluginFields on Plugin {
  id
  projectId
  typeId
  title
  useForAllStates
  stateIds
  configuration
}`;

const webhookFields = gql`
fragment webhookFields on Webhook {
  id
  enabled
  status
  callbackUrl
  triggers {
    name
    stateId
  }
}`;

const flowFields = gql`
fragment flowFields on Flow {
  id
  name
  location
  deletePermission {
    ...deletePermissionFields
  }
}
${deletePermissionFields}`;

const transitionFields = gql`
fragment transitionFields on Transition {
  id
  transitionEventId
  stateFromId
  stateToId
}
`;

const transitionEventFields = gql`
fragment transitionEventFields on TransitionEvent {
  id
  name
  deletePermission {
    ...deletePermissionFields
  }
}
${deletePermissionFields}`;

const itemFilterFields = gql`
fragment itemFilterFields on ItemFilter {
  excludeAllStates
  stateIdsIncluded
  stateIdsExcluded
  flowIdsAssigned
  flowIdsUnassigned
}`;

const actionFields = gql`
fragment actionFields on Action {
  id
  title
  transitionEventId
  flowIdForUserAssignment
  itemFilter {
    ...itemFilterFields
  }
}
${itemFilterFields}`;

const boardFields = gql`
fragment boardFields on Board {
  id
  name
  projectId
  aclRole
}`;

const projectFields = gql`
fragment projectFields on Project {
  id
  name
  apiSecretKey
  aclRole
  itemListViewTemplate {
    type
    template
  }
  plugins {
    ...pluginFields
  }
  webhooks {
    ...webhookFields
  }
  flows {
    ...flowFields
  }
  states {
    ...stateFields
  }
  transitions {
    ...transitionFields
  }
  transitionEvents {
    ...transitionEventFields
  }
  actions {
    ...actionFields
  }
  boards {
    ...boardFields
  }
}
${pluginFields}
${webhookFields}
${flowFields}
${stateFields}
${transitionFields}
${transitionEventFields}
${actionFields}
${boardFields}`;

const projectFieldsForList = gql`
fragment ProjectInProjectList on Project {
  id
  name
  apiSecretKey
  aclRole
}`;

const queueItemButtonFragment = gql`
fragment QueueItemButtonFragment on QueueItemButton {
  id
  title
  eventName
  flowIdForUserAssignment
}`;


const itemFragment = gql`
fragment ItemFragment on Item {
  id
  clientId
  createdAt
  updatedAt
  tags
  data
  assignedUsers {
    user {
      id
      email
    }
    flow {
      id
      name
    }
  }
  states {
    id
    name
  }
}`;


const queueItemListFragment = gql`
fragment QueueItemListFragment on ItemList {
    items {
        ...ItemFragment
    }
    total
    hasMore
    nextCursor
}
${itemFragment}`;



const queueFragment = gql`
fragment QueueFragment on Queue {
  id
  name
  aclRole
  projectId
  boardId
  itemFilter {
    ...itemFilterFields
  }
  query {
    type
    query
  }
  itemListViewTemplate {
    type
    template
  }
  itemViewButtons {
    ...QueueItemButtonFragment
  }
}
${itemFilterFields}
${queueItemButtonFragment}`;


export default {
    userFields,
    aclFields,
    deletePermissionFields,
    stateFields,
    pluginFields,
    webhookFields,
    flowFields,
    transitionFields,
    transitionEventFields,
    itemFilterFields,
    actionFields,
    boardFields,
    projectFields,
    projectFieldsForList,
    queueItemListFragment,
    itemFragment,
    queueItemButtonFragment,
    queueFragment
};



// WEBPACK FOOTER //
// ./src/graphql/fragments.js